<div class="loading-spinner sm-bg-white" *ngIf="loading">
  <div class="cc-icon cc-icon-spinner-3x"></div>
</div>

<div *ngIf="!loading && register?.isEmpty" class="empty-list">
  <img class="img-responsive" src="./assets/images/templates-empty-state-bg.png" />
  <h3 class="h3" i18n>No forms have been created yet</h3>
  <div>
    <p *ngIf="canAdd" class="default-paragraph" i18n>You can be the first!</p>
    <p>
      <a *ngIf="canAdd" class="btn btn-lg btn-success btn-add-form" routerLink="./new" i18n>Add form</a>
      <a
        class="btn btn-lg btn-outline-secondary"
        href="https://intercom.help/dashpivot/getting-started/forms-registers-and-workflows"
        target="_blank"
        i18n
        >Learn more</a
      >
    </p>
  </div>
</div>

<div *ngIf="hasLoadedNonEmptyRegister" class="register-view-main">
  <virtual-scroller
    [bufferAmount]="5"
    #scroll
    [items]="register.columns"
    horizontal="true"
    useMarginInsteadOfTranslate="true"
  >
    <div class="forms-register-selection-column">
      <div class="forms-register-header-cell forms-register-selection-cell">
        <cc-tool-tip
          [contentText]="selectAll.selected ? labels.deselectAllForms : labels.selectAllForms"
          placement="right"
        >
          <button
            type="button"
            class="forms-register-selection-checkbox"
            aria-role="checkbox"
            data-test="select-all-forms"
            (click)="handleSelectAll()"
            [attr.aria-checked]="selectAll.selected"
            [attr.aria-label]="selectAll.selected ? labels.deselectAllForms : labels.selectAllForms"
          >
            <i class="cc-icon cc-icon-check" aria-hidden="true"></i>
          </button>
        </cc-tool-tip>
      </div>
      <div
        class="forms-register-field-cell forms-register-selection-cell"
        [class.expanded]="expandedRows.has(field.formId)"
        *ngFor="let field of register.columns[0].fields"
      >
        <button
          type="button"
          class="forms-register-selection-checkbox"
          aria-role="checkbox"
          data-test="select-form"
          (click)="handleSelectForm(field.formId)"
          [attr.aria-label]="selectAll.selected || selectedForms.has(field.formId)
            ? labels.deselectSingleForm
            : labels.selectSingleForm"
          [attr.aria-checked]="selectAll.selected || selectedForms.has(field.formId)"
        >
          <i class="cc-icon cc-icon-check cc-icon-sm" aria-hidden="true"></i>
        </button>
        <button
          class="expand-row-button"
          type="button"
          (click)="handleExpandRow(field.formId)"
          [attr.aria-label]="expandedRows.has(field.formId)
            ? labels.contractSingleForm
            : labels.expandSingleForm"
        >
          <i class="cc-icon cc-icon-arrow-right" aria-hidden=true></i>
        </button>
      </div>
    </div>
    <div class="forms-register-column-container" #container>
      <div class="forms-register-column" *ngFor="let column of scroll.viewPortItems">
        <header
          *ngFor="let headerColumn of column.header.columns"
          class="forms-register-header-cell"
        >
          <cc-form-field-header
            [static]="false"
            (filterChanged)="filtersChanged()"
            [column]="headerColumn"
          ></cc-form-field-header>
        </header>
        <div
          class="forms-register-field-cell-container"
          *ngFor="let field of column.fields"
          [class.expanded]="expandedRows.has(field.formId)"
        >
          <div
            class="forms-register-field-cell"
            (click)="handleRowClick(field.formId)"
            *ngFor="let row of field.grid"
            [class.expanded]="field.expandable && expandedRows.has(field.formId)"
            [class.table-cell]="[fieldKinds.Table, fieldKinds.PrefilledTable].includes(field.kind)"
          >
            <cc-form-field *ngFor="let cell of row" [column]="cell"></cc-form-field>
          </div>
        </div>
      </div>
    </div>
  </virtual-scroller>
</div>

<div class="loading-more" *ngIf="loadingMore">
  <div class="loading-spinner">
    <div class="cc-icon cc-icon-spinner-3x"></div>
  </div>
</div>
